<template>
  <div class="container">
    <div class="step1">
      <div class="formWrap" v-loading="loading">
        <div class="form">
          <div class="ticketType">
            <template v-if="model == 'store'">
              <div class="ticketName">{{ goods.name }}</div>
            </template>
            <template v-if="model == 'ticket'">
              <div class="ticketName">{{ scenic.name }}</div>
            </template>
            <template v-if="model == 'package'">
              <div class="ticketName">{{ hotel.name }}</div>
            </template>
            <template v-if="model == 'hotel'">
              <div class="ticketName">{{ hotel.name }}</div>
            </template>

            <div class="types">
              <template v-if="model == 'store'">
                <div :class="[
        'typeItem',
        { active: form.goods_prop_id == item.id },
      ]" @click="changeProp(item.id)" v-for="(item, index) in goods.normalProp" :key="index">
                  {{ item.name }} <span class="mgl20 fs12" v-if="debug">剩余：{{ item.stock }}</span>
                  <img class="activeIcon" v-if="form.goods_prop_id == item.id" src="~@/assets/images/u1225.svg"
                    alt="" />
                </div>
              </template>
              <template v-else>
                <div :class="['typeItem', { active: form.goods_id == item.id }]" @click="changeGoods(item.id)"
                  v-for="(item, index) in goodsList" :key="index">
                  {{ item.name }}
                  <img class="activeIcon" v-if="form.goods_id == item.id" src="~@/assets/images/u1225.svg" alt="" />
                </div>
              </template>
            </div>
            <el-card v-if="['ticket', 'package', 'hotel'].includes(model) && goods.travel_type == 0" class="calendar"
              shadow="never">
              <div class="header">
                <el-button type="primary" icon="el-icon-arrow-left" size="small" @click="lastMonth"></el-button>
                <p>{{ showMonth }}</p>
                <el-button type="primary" icon="el-icon-arrow-right" size="small" @click="nextMonth"></el-button>
              </div>
              <div class="week">
                <span>一</span>
                <span>二</span>
                <span>三</span>
                <span>四</span>
                <span>五</span>
                <span>六</span>
                <span>日</span>
              </div>
              <div class="list">
                <div @click="chooseDate(item, index)" :class="[
        'item',
        { disabledDate: item.disabled, isSelect: item.selected },
      ]" v-for="(item, index) in dateList" :key="index">
                  <div class="day">{{ item.day }}</div>
                  <div class="dayPrice">￥{{ item.price }}</div>
                  <template v-if="model == 'hotel'">
                    <span v-if="form.start_date == item.date" class="in">入住</span>
                    <span v-if="form.end_date == item.date" class="out">离店</span>
                  </template>
                  <div class="fs12 colorGold" v-if="item.stock > 0 && debug">剩余：{{ item.stock }}</div>
                </div>
              </div>
            </el-card>
          </div>
          <div class="tip">
            <div class="title">
              <img src="@/assets/images/notice.svg" alt="" />
              <span>预定须知</span>
            </div>
            <span class="content" v-html="goods.knowledge"> </span>
          </div>
        </div>
        <div class="info">
          <el-form ref="form" :model="form" :rules="formRules" label-width="105px" style="width: 450px"
            label-suffix="：">
            <div class="infoItem">
              <div class="title">
                <i class="el-icon-s-flag"></i>
                <span v-if="model == 'store'">购买信息</span>
                <span v-else>游玩信息</span>
              </div>
              <template v-if="model == 'store'">
                <el-form-item label="提货方式" prop="express_type">
                  <el-radio-group v-model="form.express_type">
                    <el-radio :label="1" v-if="goods.express_type.includes('1')">自提</el-radio>
                    <el-radio :label="0" v-if="goods.express_type.includes('0')">快递配送</el-radio>
                  </el-radio-group>
                  <div v-if="form.express_type == 1" class="tips">
                    自提地址：<span>{{ goods.fetch_address }}</span>
                  </div>
                </el-form-item>
              </template>
              <template v-else>
                <template v-if="goods.travel_type == 1">
                  <el-form-item label="有效期">
                    <el-date-picker style="width: 100%" :value="[form.start_date, form.end_date]" type="daterange"
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" disabled>
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="库存" v-if="debug">
                    <div class="colorGold">{{ goods.stock }}</div>
                  </el-form-item>
                </template>
                <template v-else>
                  <el-form-item :label="`${model == 'hotel' ? '入住' : '游玩'}日期`" prop="start_date">
                    <el-date-picker style="width: 100%" v-model="form.start_date" type="date" :placeholder="`选择${model == 'hotel' ? '入住' : '游玩'}日期`
        " disabled>
                    </el-date-picker>
                  </el-form-item>
                </template>

                <el-form-item v-if="model == 'hotel' && goods.travel_type == 0" label="离店日期" prop="end_date">
                  <el-date-picker style="width: 100%" v-model="form.end_date" type="date" placeholder="选择离店日期" disabled>
                  </el-date-picker>
                </el-form-item>
              </template>

              <el-form-item label="购买数量" prop="quantity">
                <el-input-number v-model="form.quantity" :min="1" :max="goods.limit ? goods.limit : 9999"
                  style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="价格">
                <span class="price">￥{{ payAmount }}</span>
              </el-form-item>
            </div>
            <div class="infoItem">
              <div class="title">
                <i class="el-icon-s-custom"></i>
                <span>联系人信息</span>
              </div>
              <el-form-item label="联系人" prop="name">
                <el-input v-model="form.name" placeholder="请填写联系人"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="form.phone" placeholder="请填写手机号"></el-input>
              </el-form-item>
              <template v-if="model == 'store'">
                <template v-if="form.express_type == 0">
                  <el-form-item label="地址" prop="areaArr">
                    <el-cascader style="width: 100%" v-model="form.areaArr" placeholder="请选择地址" clearable
                      :props="cascaderProp" :options="areaList">
                    </el-cascader>
                  </el-form-item>

                  <el-form-item label="" prop="detail">
                    <el-input type="textarea" :rows="2" :autosize="{ minRows: 2, maxRows: 4 }" v-model="form.detail"
                      placeholder="请填写详细地址"></el-input>
                  </el-form-item>
                </template>
              </template>
              <template v-else>
                <el-form-item label="证件号" prop="idcard">
                  <el-input v-model="form.idcard" placeholder="请填写证件号"></el-input>
                </el-form-item>
              </template>
            </div>
            <div class="infoItem">
              <div class="title">
                <i class="el-icon-s-ticket"></i>
                <span>优惠信息</span>
              </div>
              <el-form-item label="优惠券" prop="user_coupon_id">
                <el-select v-model="form.user_coupon_id" clearable placeholder="请选择优惠" style="width: 100%"
                  no-data-text="暂无可用优惠券">
                  <el-option v-for="item in couponList" :key="item.id" :label="item.name" :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #ff3d2e; font-size: 13px">可优惠{{ item.price }}元</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div class="totalBar">
        <div class="info">
          <span>订单金额</span>
          <span class="price">￥{{ orderAmount }}</span>
          <span>-</span>
          <span>优惠金额</span>
          <span class="price">￥{{ couponAmount }}</span>
          <template v-if="express_fee > 0">
            <span>+</span>
            <span>运费</span>
            <span class="price">￥{{ express_fee }}</span>
          </template>
          <span>=</span>
          <span>支付总额</span>
          <span class="price">￥{{ payAmount }}</span>
        </div>
        <div class="submitBtn" @click="handleAddOrder">提交订单</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getOrderPreview,
  getCalendarList,
  getCanUseCouponList,
  getExpressFee,
  addOrder,
} from "@/api/order";
import { getAreaTree } from "@/api/common";
import moment from "moment";
export default {
  name: "OrderAdd",
  components: {},
  data() {
    return {
      dateList: [],
      goodsList: [],
      couponList: [],
      form: {
        goods_id: null,
        goods_prop_id: null,
        scenic_id: null,
        hotel_id: null,
        month: moment().format("YYYY-MM"),
        quantity: 1,
        name: "",
        phone: "",
        idcard: "",
        start_date: "",
        end_date: "",
        timeRange: [],
        user_coupon_id: null,
        areaArr: [],
        province_id: null,
        city_id: null,
        district_id: null,
        detail: "",
        express_type: 0,
      },
      areaList: [],
      cascaderProp: {
        value: "id",
        label: "name",
        children: "_child",
        disabled: "disabled",
      },
      formRules: {
        areaArr: [{ required: true, message: "请选择地址", trigger: "blur" }],
        province_id: [{ required: true, message: "请选择省", trigger: "blur" }],
        city_id: [{ required: true, message: "请选择市", trigger: "blur" }],
        district_id: [{ required: true, message: "请选择区", trigger: "blur" }],
        detail: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        start_date: [
          {
            required: true,
            message:
              "请选择" +
              (this.$route.params.model == "hotel" ? "入住" : "游玩") +
              "日期",
            trigger: "blur",
          },
        ],
        end_date: [
          {
            required: true,
            message: "请选择离店日期",
            trigger: "blur",
          },
        ],
        quantity: [
          { required: true, message: "请选择购买数量", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        idcard: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          {
            pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
            message: "证件号码格式不正确",
            trigger: "blur",
          },
        ],
      },
      goods: {
        normalProp: [],
        express_type: [],
      },
      hotel: {},
      scenic: {},
      loading: false,
      model: null,
      buy_type: 0,
      express_fee: 0,
    };
  },
  computed: {
    debug() {
      return true;
      return process.env.NODE_ENV === "development";
    },
    orderAmount() {
      let amount = 0;
      let price = 0;
      if (this.model == "store") {
        price = (this.form.goods_prop_id && this.goods.normalProp.length > 0)
          ? this.goods.normalProp.find(
            (item) => item.id == this.form.goods_prop_id
          ).price
          : 0;
      } else {
        if (this.goods.travel_type == 1) {
          price = this.goods.price
        } else {
          if (this.model == 'hotel') {
            const selected = this.dateList.filter((item) => item.selected);
            price = selected.slice(0, selected.length - 1).reduce((a, b) => {
              return parseFloat(a) + parseFloat(b.price);
            }, 0);
          } else {
            price = this.dateList.filter((item) => item.selected).reduce((a, b) => {
              return parseFloat(a) + parseFloat(b.price);
            }, 0);
          }
        }
        console.log(price)
      }
      amount = parseFloat(price) * this.form.quantity;
      return amount.toFixed(2);
    },
    payAmount() {
      return (
        parseFloat(this.orderAmount) -
        parseFloat(this.couponAmount) +
        parseFloat(this.express_fee)
      ).toFixed(2);
    },
    couponAmount() {
      let amount = 0;
      if (this.form.user_coupon_id)
        amount = this.couponList.find(
          (item) => item.id == this.form.user_coupon_id
        ).price;
      return parseFloat(amount).toFixed(2);
    },
    showMonth() {
      return moment(this.form.month).format("YYYY年MM月");
    },
  },
  watch: {
    "form.goods_prop_id"(val) {
      if (val) {
        this.getCouponList();
        if (this.model == "store" && this.form.express_type == 0) {
          this.getExpressFee();
        } else {
          this.express_fee = 0;
        }
      }
    },
    "form.goods_id"(val) {
      if (val) {
        this.getOrderPreview();
      }
    },
    "form.start_date"(val) {
      if (val) {
        this.getCouponList();
      }
    },
    "form.end_date"(val) {
      if (val) {
        this.getCouponList();
      }
    },
    "form.quantity"(val) {
      if (val) {
        this.getCouponList();
        if (this.model == "store" && this.form.express_type == 0) {
          this.getExpressFee();
        } else {
          this.express_fee = 0;
        }
      }
    },
    "form.areaArr"(val) {
      if (val) {
        if (this.model == "store" && this.form.express_type == 0) {
          this.getExpressFee();
        } else {
          this.express_fee = 0;
        }
      }
    },
    "form.express_type"(val) {
      if (val) {
        this.express_fee = 0;
      } else {
        this.getExpressFee();
      }
    },
  },
  created() {
    this.model = this.$route.params.model;
    this.buy_type = parseInt(this.$route.params.buy_type) || 0;
    this.$store.dispatch("setModel", this.model);
    this.form.goods_id = parseInt(this.$route.params.goods_id) || 0;
    this.form.goods_prop_id = parseInt(this.$route.params.prop_id) || 0;
    if (this.model == "store") {
      this.form.hotel_id = 0;
      this.form.scenic_id = 0;
    } else if (this.model == "ticket") {
      this.form.hotel_id = 0;
      this.form.scenic_id = this.$route.params.mid;
    } else {
      this.form.hotel_id = this.$route.params.mid;
      this.form.scenic_id = 0;
    }
    this.getAreaTree();
    this.getOrderPreview();
    // this.getCalendarList()
    // if (this.debug) {
    //   this.form.name = '张三'
    //   this.form.phone = '13888888888'
    //   if (this.model != 'store') {
    //     this.form.idcard = '32032119891002065X'
    //   } else {
    //     this.form.areaArr = [320000, 320400, 320411]
    //     this.form.detail = '新北区'
    //   }
    // }
  },
  mounted() {
    this.formatPrice = this.utils.formatPrice;
  },
  methods: {
    lastMonth() {
      this.form.month = moment(this.form.month)
        .subtract(1, "month")
        .format("YYYY-MM");
      this.getOrderPreview();
    },
    nextMonth() {
      this.form.month = moment(this.form.month)
        .add(1, "month")
        .format("YYYY-MM");
      this.getOrderPreview();
    },
    getAreaTree() {
      getAreaTree({}).then((res) => {
        this.areaList = res.data;
      });
    },
    getCalendarList() {
      this.loading = true;
      getCalendarList({
        month: this.form.month,
      })
        .then((res) => {
          this.loading = false;
          this.dateList = res.data.dateList;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getOrderPreview() {
      this.loading = true;
      const _form = JSON.parse(JSON.stringify(this.form));
      _form.buy_type = this.buy_type;
      _form.model = this.model;
      getOrderPreview(_form)
        .then((res) => {
          this.loading = false;
          this.goodsList = res.data.goodsList;
          this.goods = res.data.goods;
          if (res.data.goods.travel_type == 1) {
            this.form.start_date = res.data.goods.use_start_time
            this.form.end_date = res.data.goods.use_end_time
          } else {
            this.resetForm();
          }
          if (this.model == "store" && !this.form.goods_prop_id) {
            //默认选中第一个
            this.form.goods_prop_id = this.goods.normalProp[0].id;
          }

          this.scenic = res.data.scenic;
          this.hotel = res.data.hotel;
          this.dateList = res.data.dateList.map((item) => {
            item.selected = false;
            return item;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    resetForm(value) {
      this.form.user_coupon_id = null;
      this.form.start_date = "";
      this.couponList = [];
    },
    getCouponList() {
      getCanUseCouponList({
        goods_id: this.form.goods_id,
        order_amount: this.orderAmount,
        quantity: this.form.quantity
      }).then((res) => {
        this.couponList = res.data;
      });
    },
    getExpressFee() {
      const _form = JSON.parse(JSON.stringify(this.form));
      _form.province_id = _form.areaArr ? _form.areaArr[0] : 0;
      _form.city_id = _form.areaArr ? _form.areaArr[1] : 0;
      _form.district_id = _form.areaArr ? _form.areaArr[2] : 0;
      getExpressFee(_form).then((res) => {
        this.express_fee = res.data.toFixed(2);
      });
    },
    chooseDate(item, index) {
      if (item.disabled) return false;
      if (this.model == "hotel") {
        if (!this.form.start_date && !this.form.end_date) {
          this.form.start_date = item.date;
        } else if (this.form.start_date && !this.form.end_date) {
          let startDateIndex = this.dateList.findIndex(
            (item) => item.date == this.form.start_date
          );
          if (startDateIndex > index || item.date == this.form.start_date) {
            return this.$message.error("离店日期需晚于入住日期");
          }
          this.form.end_date = item.date;
        } else {
          this.form.start_date = item.date;
          this.form.end_date = "";
        }
      } else {
        this.form.start_date = item.date;
      }
      let startDateIndex = this.dateList.findIndex(
        (item) => item.date == this.form.start_date
      );
      let endDateIndex = this.dateList.findIndex(
        (item) => item.date == this.form.end_date
      );
      if (endDateIndex < 0) endDateIndex = startDateIndex;
      console.log(startDateIndex, endDateIndex);
      const errors = [];
      this.dateList.map((item, index) => {
        if (startDateIndex <= index && endDateIndex >= index) {
          if (item.disabled) errors.push(item.date);
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
      if (errors.length > 0) {
        this.form.start_date = ""
        this.form.end_date = ""
        this.dateList.map((item, index) => {
          item.selected = false;
        });
        return this.$message.error(errors.join("、") + "不可预，请重新选择");
      }
    },
    changeProp(id) {
      this.form.goods_prop_id = id;
    },
    changeGoods(id) {
      this.form.goods_id = id;
    },
    // 提交订单
    handleAddOrder() {
      if (this.form.quantity > this.goods.stock) {
        return this.$message.error('库存不足！')
      }
      this.$refs.form.validate((valid, errors) => {
        if (valid) {
          const _form = JSON.parse(JSON.stringify(this.form));
          _form.province_id = _form.areaArr ? _form.areaArr[0] : 0;
          _form.city_id = _form.areaArr ? _form.areaArr[1] : 0;
          _form.district_id = _form.areaArr ? _form.areaArr[2] : 0;
          _form.model = this.model;
          _form.buy_type = this.buy_type;
          delete _form.areaArr;
          this.loading = true;
          addOrder(_form)
            .then((res) => {
              this.loading = false;
              this.$message({
                type: "success",
                message: "下单成功!",
              }),
                setTimeout(() => {
                  this.$router.push({
                    name: "orderPay",
                    params: { id: res.data.id },
                  });
                }, 1000);
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log(errors);
          Object.values(errors).forEach((item, index) => {
            setTimeout(() => {
              this.$message.error(item[0]["message"]);
            }, 200 * index);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 50px;

  .step1 {
    width: 75.7%;
    min-width: 1200px;

    .formWrap {
      width: 100%;
      display: grid;
      grid-template-columns: 864fr 560fr;
      column-gap: 16px;
      margin-bottom: 38px;

      .form {
        .ticketType {
          width: 100%;
          padding: 17px 20px;
          box-sizing: border-box;
          background-color: #f7f7f7;

          .ticketName {
            font-weight: 650;
            font-style: normal;
            font-size: 28px;
            color: #000000;
            margin-bottom: 12px;
          }

          .types {
            display: flex;
            flex-wrap: wrap;
            column-gap: 15px;
            row-gap: 13px;

            .typeItem {
              font-weight: 650;
              font-style: normal;
              font-size: 14px;
              color: #909399;
              text-align: center;
              padding: 10px 25px;
              border: 1px solid rgba(144, 147, 153, 1);
              cursor: pointer;
              position: relative;

              .activeIcon {
                position: absolute;
                width: 10px;
                height: 8px;
                left: 11px;
                top: 13px;
              }
            }

            .active {
              color: white;
              background: rgb(99, 171, 182);
              border: 1px solid rgba(99, 171, 182, 1);
            }
          }

          .calendar {
            margin-top: 18px;
            color: #606266;
            font-weight: 400;

            .header {
              display: grid;
              grid-template-columns: 45px auto 45px;
              align-items: center;
              text-align: center;
              padding-bottom: 20px;
              border-bottom: 1px solid #ebeeea;
            }

            .week {
              padding-top: 20px;
              display: grid;
              grid-template-columns: repeat(7, 1fr);
              text-align: center;
            }

            .list {
              display: grid;
              grid-template-columns: repeat(7, 1fr);
              text-align: center;
              border-top: 1px solid #ebeeea;
              border-left: 1px solid #ebeeea;
              margin-top: 15px;

              .item {
                border-right: 1px solid #ebeeea;
                border-bottom: 1px solid #ebeeea;
                padding: 15px 8px;
                display: flex;
                flex-direction: column;
                row-gap: 15px;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                min-height: 78px;
                position: relative;

                .day {}

                .dayPrice {
                  color: red;
                }

                .in {
                  position: absolute;
                  left: 5px;
                  top: 10px;
                  font-size: 12px;
                  transform: rotate(-45deg);
                  color: #fff;
                }

                .out {
                  position: absolute;
                  right: 5px;
                  top: 10px;
                  font-size: 12px;
                  transform: rotate(45deg);
                  color: #fff;
                }
              }

              .item:hover {
                background-color: #63abb6;
                color: #ffffff;

                .dayPrice {
                  color: #ffffff;
                }
              }

              .isSelect {
                background-color: #63abb6;
                color: #ffffff;

                .dayPrice {
                  color: #ffffff;
                }
              }

              .disabledDate {
                cursor: not-allowed;

                .day {
                  color: #c0c4cc !important;
                }

                .dayPrice {
                  display: none;
                }
              }
            }
          }
        }

        .tip {
          width: 100%;
          padding: 25px 20px;
          box-sizing: border-box;
          border: solid 1px #eaeaea;
          margin-top: 18px;

          .title {
            display: flex;
            align-items: center;
            column-gap: 8px;
            font-weight: 650;
            font-style: normal;
            font-size: 18px;
            color: #303133;
            margin-bottom: 25px;

            img {
              width: 30px;
              height: 30px;
            }
          }

          .content {
            font-weight: 400;
            font-style: normal;
            font-size: 14px;
            line-height: 24px;
          }
        }
      }

      .info {
        width: 100%;
        border: solid 1px #eaeaea;
        padding: 25px 20px;
        box-sizing: border-box;

        .infoItem {
          .title {
            margin-bottom: 30px;
            font-weight: 650;
            font-style: normal;
            font-size: 18px;
            color: #303133;
            display: flex;
            align-items: center;

            i {
              font-size: 31px;
              margin-right: 15px;
            }
          }

          .tips {
            font-size: 13px;
            color: #666;
          }
        }
      }
    }

    .totalBar {
      width: 100%;
      display: grid;
      align-items: center;
      grid-template-columns: 1155fr 285fr;
      background-color: #f7f7f7;
      position: sticky;
      bottom: 0;
      z-index: 9;
      margin-top: 200px;

      .info {
        display: flex;
        align-items: center;
        column-gap: 20px;
        padding-left: 50px;
        box-sizing: border-box;
      }

      .submitBtn {
        width: 100%;
        font-weight: 500;
        font-style: normal;
        font-size: 26px;
        color: #ffffff;
        cursor: pointer;
        background-color: rgba(150, 33, 35, 1);
        text-align: center;
        padding: 25px 0;
        box-sizing: border-box;
      }
    }
  }
}

.price {
  font-weight: 650;
  font-style: normal;
  color: #ff3d2e;
  font-size: 24px;
}

.service {
  margin-top: 50px;
}

::v-deep .el-range-separator {
  padding: 0;
}
</style>
